// 抽签抽酒店免接口，操作枚举
export var OperateType;
(function (OperateType) {
    OperateType[OperateType["queryDraw"] = 1] = "queryDraw";
    // 查询
    OperateType[OperateType["drawFree"] = 2] = "drawFree";
    // 抽免单
    OperateType[OperateType["lightUpCity"] = 3] = "lightUpCity"; // 许愿城市
})(OperateType || (OperateType = {}));
// 抽奖状态枚举
export var DrawStatus;
(function (DrawStatus) {
    DrawStatus[DrawStatus["unDraw"] = 0] = "unDraw";
    // 未抽奖
    DrawStatus[DrawStatus["drawSuccess"] = 1] = "drawSuccess";
    // 抽奖成功
    DrawStatus[DrawStatus["drawFail"] = 2] = "drawFail"; // 抽奖失败
})(DrawStatus || (DrawStatus = {}));
export var CityOrderTaskStatus;
(function (CityOrderTaskStatus) {
    CityOrderTaskStatus[CityOrderTaskStatus["init"] = 0] = "init";
    // 初始未下单状态
    CityOrderTaskStatus[CityOrderTaskStatus["waitingDraw"] = 1] = "waitingDraw";
    // 待抽奖
    CityOrderTaskStatus[CityOrderTaskStatus["drawSuccess"] = 2] = "drawSuccess"; // 已中免单
})(CityOrderTaskStatus || (CityOrderTaskStatus = {}));
